import React from 'react';
import Tophead from '../templates/tophead';
function Contactus(){
    return(
      <div>
         <Tophead/>
         agew4545435
      </div>
    )
}
export default Contactus;